<template>
	<!-- <div class="loader-overlay" v-if="status">
  		<v-progress-circular indeterminate color="primary"></v-progress-circular>
	</div> -->
    <loading :active.sync="status" 
        :can-cancel="false" 
        :is-full-page="false"
        color="#007bff">
    </loading>
</template>

<script>
import Loading from 'vue-loading-overlay';

export default {
    props: ["status"],
    components: {
        Loading
    }
};
</script>
